// Photo albums for a vehicle. Every photo belongs to exactly one album; photos
// uploaded before albums existed have no value and count as "main".
export const PHOTO_ALBUMS = [
  { key: 'main',        label: 'Main' },
  { key: 'restoration', label: 'Restoration' },
  { key: 'interior',    label: 'Interior' },
  { key: 'engine',      label: 'Engine & Bay' },
  { key: 'details',     label: 'Details' },
];

export const albumOf = (photo) =>
  PHOTO_ALBUMS.some(a => a.key === photo?.album) ? photo.album : 'main';

export const albumLabel = (key) =>
  PHOTO_ALBUMS.find(a => a.key === key)?.label || 'Main';
